import Component from '../abstracts/Component';

export default class EditorialComponent extends Component {
  get SELECTORS() {
    return {
      main: '.media-container',
      header: '.c-main-header'
    };
  }

  setHeight() {
    let vh = window.innerHeight * 0.01;
    let headerHeight = this.dom.header ? this.dom.header.offsetHeight : 0;
    let totalHeight = headerHeight + 32;
    document.documentElement.style.setProperty('--media-section-top',`${totalHeight}px`);
  }

  readDOM() {
    return {
      main: this.$component.querySelector(this.SELECTORS.main),
      header: document.querySelector(this.SELECTORS.header),
    }
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.setHeight();
  }
}
